import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dnl-comp1',
  templateUrl: './comp1.component.html',
  styleUrls: ['./comp1.component.css']
})
export class Comp1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
